import React from "react";
import styles from "./index.module.css";

const Loader = ({ spinner }) => {
  return (
    <div className={styles["page__loader"]}>
      <span
        className={spinner ? styles["loader_bubble"] : styles["loader"]}
      ></span>
    </div>
  );
};

export default Loader;
